// extracted by mini-css-extract-plugin
export default {"AddPart":"styles_AddPart__mYE8F","AddPart-form_container":"styles_AddPart-form_container__woh9G","AddPart-btnContainer":"styles_AddPart-btnContainer__5HY+h"};